export const hasPositiveQuantity = (value) => {
  if (typeof value !== 'number' && typeof value !== 'string') return false
  if (typeof value === 'string' && value.trim() === '') return false

  const quantity = Number(value)
  return Number.isSafeInteger(quantity) && quantity > 0
}

const asArray = (value) => Array.isArray(value) ? value : []

const hasPositivePrice = (value) => {
  if (typeof value !== 'number' && typeof value !== 'string') return false
  if (typeof value === 'string' && value.trim() === '') return false

  const price = Number(value)
  return Number.isFinite(price) && price > 0
}

export const pruneCartItems = (items = []) =>
  asArray(items)
    .filter((item) => hasPositiveQuantity(item?.quantity))
    .map((item) => {
      const extra = item.extra && typeof item.extra === "object" ? item.extra : {}
      const nextExtra = {}

      for (const [key, value] of Object.entries(extra)) {
        if (hasPositiveQuantity(value?.quantity)) {
          nextExtra[key] = value
        }
      }

      return {
        ...item,
        extra: nextExtra,
      }
    })

export const sanitizePluItems = (items = []) =>
  asArray(items).filter((item) =>
    item !== null &&
    typeof item === 'object' &&
    hasPositiveQuantity(item.amount)
  )

export const sanitizeDbOrderItems = (items = []) =>
  asArray(items)
    .filter((item) => hasPositiveQuantity(item?.quantity))
    .map((item) => ({
      ...item,
      extra: Array.isArray(item.extra)
        ? item.extra.filter((extra) => hasPositiveQuantity(extra?.quantity))
        : [],
    }))

export const shouldIncludeDeliveryItem = ({
  deliveryPrice,
  isPersonalPickUp,
  isTableOrder,
}) =>
  !isPersonalPickUp &&
  !isTableOrder &&
  hasPositivePrice(deliveryPrice)

export const shouldApplyAddressMinimums = ({
  isPersonalPickUp,
  isTableOrder,
}) => !isPersonalPickUp && !isTableOrder

export const nextCartExtras = (extra, productId, extraItem) => {
  const current = extra && typeof extra === "object" ? { ...extra } : {}

  if (!productId || !hasPositiveQuantity(extraItem?.quantity)) {
    delete current[productId]
    return current
  }

  current[productId] = extraItem
  return current
}
